import React, { useState } from "react";
import { Link } from "react-router-dom";
import CarouselListCont from "../carousel/CarouselListCont";

export default function Productos() {
  const [openProductos, setOpenProductos] = useState(false);
  const closeGallery = () => {
    setOpenProductos(false)
  }
  const gallery = [
    {
      url: "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2F01-tapaPityHeroesv02.jpg?alt=media&token=4bf376ee-2842-4444-be1a-000c49a06bd5",
    },
{  url:    "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2F01JuanFerHeroesTAPA.jpg?alt=media&token=a7a58638-106f-47ff-a986-b4d5a3e090d8"},
    { url: "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2F03LucasPratoHeroesTAPA.jpg?alt=media&token=d9c8862c-bade-4149-a2c9-dbbb3ff60fc7"},
    { url: "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2Ftres%20libros.png?alt=media&token=76b24fab-3b66-4666-abc8-9c21438422d2"},
    { url: "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2FLibro-Eterna---Copa-Libertadores-2019.png?alt=media&token=1367b38d-7d91-4592-a14b-1097eb6acd7b"},
    { url: "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2FReviposterRiverCampeon_alta_page-0001.jpg?alt=media&token=11ce6d3c-9e95-4240-bd41-bc26136251f7"},
    { url: "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2FReviposterRiverCampeon_alta_page-0002.jpg?alt=media&token=84e526a7-c552-4d19-8e57-875d9306bcad"},
  ];
  return (
    <section className="section" id="productos">
      <h2 className="title"> PRODUCTOS </h2>
      <div className="row-wrap">
        <div className="profile-cont">
          <img
            className="profile-pic nograyscale"
            src="https://acdn.mitiendanube.com/stores/098/632/themes/idea/2-img-2141098475-1678376847-8b8b8c3b48bfedb48a6a20435aeef55f1678376848-1024-1024.webp?1795816017"
            alt=""
          />
          <p className="profile-name">Revista 1986</p>
          <p className="profile-description">
            La revista busca enaltecer la cultura popular que emana del club más
            importante de la Argentina. Es un proyecto que reúne a periodistas,
            escritores y fotógrafos que consideran que River merece un nuevo
            lenguaje periodístico.{" "}
          </p>
          <b className="profile-description2">
            REVISTA MENSUAL. <br />
            TIRADA: 20000 EJEMPLARES. <br /> DISTRIBUCION NACIONAL.
          </b>
        </div>
        {/* 
        <div className="profile-cont">
          <img
            className="profile-pic nograyscale"
            src="https://acdn.mitiendanube.com/stores/098/632/themes/idea/2-slide-1634848615020-1428501472-6c31372669d18fb7abc242624951bc3e1634848626-1920-1920.webp?1795816017"
            alt=""
          />
          <p className="profile-name">Tienda 1986</p>
          <p className="profile-description">
            A través de la Tienda 1986 comercializamos la Revista 1986, desarrollos editoriales y otros productos del mundo River.
          </p>
        </div> */}

        <div className="profile-cont">
          <img
            className="profile-pic nograyscale"
            src="https://acdn.mitiendanube.com/stores/098/632/themes/idea/2-img-330094606-1608664498-af0ea813e3f54c93e06a07811e2c5d8c1608664499-1024-1024.webp?1795816017"
            alt=""
          />
          <p className="profile-name">Productos editoriales</p>
          <p className="profile-description">
            Coleccionables, desarrollo editorial de revipósters, pósters y
            suplementos especiales.
          </p>
          <button
            onClick={() => {
              setOpenProductos(true);
            }}
            className="buttonlink"
          >
            Ver productos
          </button>
        </div>
        
        {openProductos ? 
            <div className="gallerycont">
        
        <CarouselListCont gallery={gallery} closeGallery={closeGallery} />  
        </div> : <></>}
      </div>
    </section>
  );
}
